import { render, staticRenderFns } from "./FormAsignacion.vue?vue&type=template&id=3d8bb984&scoped=true&"
import script from "./FormAsignacion.vue?vue&type=script&lang=js&"
export * from "./FormAsignacion.vue?vue&type=script&lang=js&"
import style0 from "./FormAsignacion.vue?vue&type=style&index=0&id=3d8bb984&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8bb984",
  null
  
)

export default component.exports